export const normalizePromotionPaymentCondition = (value) =>
  value === "cash_only" ? "cash_only" : "any";

export const isCashPromotionPayment = (method) =>
  ["cash", "efectivo", "counter", "caja", "cash_on_delivery"].includes(
    String(method || "").trim().toLowerCase()
  );

// Keep the two quoted prices with the order: later collection must not use
// today's catalog or lose the original cash condition during serialization.
export const resolvePromotionPaymentPricing = (pricing, method) => {
  if (!pricing || !pricing.paymentPrices) return pricing;
  const paymentBasis = isCashPromotionPayment(method) ? "cash" : "other";
  const selected = pricing.paymentPrices[paymentBasis];
  if (!selected) return pricing;
  return { ...pricing, ...selected, paymentBasis };
};

export const resolveOrderPromotionPayment = (order, method) => {
  const pricing = resolvePromotionPaymentPricing(order?.pricing, method);
  if (!pricing?.paymentPrices) return order;
  return { ...order, pricing, totalAmount: pricing.finalTotal };
};

export const compactPromotionPaymentFields = (pricing) => {
  const manualFields = {
    ...(pricing?.manualDiscount ? { manualDiscount: { ...pricing.manualDiscount } } : {}),
    ...(pricing?.discountRevision ? { discountRevision: pricing.discountRevision } : {}),
  };
  if (!pricing?.paymentPrices?.cash || !pricing?.paymentPrices?.other) return manualFields;
  const compact = (value) => ({
    ...(value.manualDiscount ? { manualDiscount: { ...value.manualDiscount } } : {}),
    listTotal: Number(value.listTotal || 0),
    comboDiscountTotal: Number(value.comboDiscountTotal || 0),
    promotionDiscountTotal: Number(value.promotionDiscountTotal || 0),
    totalDiscount: Number(value.totalDiscount || 0),
    finalTotal: Number(value.finalTotal || 0),
    adjustments: (Array.isArray(value.adjustments) ? value.adjustments : []).map((item) => ({
      id: String(item.id || "").slice(0, 160),
      type: item.type === "manual_discount" ? "manual_discount" : item.type === "combo" ? "combo" : "promotion",
      title: String(item.title || "").slice(0, 180),
      amount: Number(item.amount || 0),
      summary: String(item.summary || item.title || "").slice(0, 240),
      paymentCondition: normalizePromotionPaymentCondition(item.paymentCondition),
    })),
  });
  return {
    ...manualFields,
    paymentBasis: pricing.paymentBasis === "other" ? "other" : "cash",
    paymentPrices: { cash: compact(pricing.paymentPrices.cash), other: compact(pricing.paymentPrices.other) },
  };
};

export const promotionPaymentNotice = (pricing, formatMoney = String) => {
  if (!pricing?.paymentPrices) return "";
  const cash = pricing.paymentPrices.cash.finalTotal;
  const other = pricing.paymentPrices.other.finalTotal;
  if (Math.abs(Number(cash) - Number(other)) < 0.01) return "";
  return pricing.paymentBasis === "other"
    ? `Este medio de pago no incluye las ofertas solo en efectivo. Nuevo total: ${formatMoney(other)}. Confirma el importe antes de continuar.`
    : `Precio en efectivo: ${formatMoney(cash)}. Con QR, Mercado Pago o tarjeta: ${formatMoney(other)}.`;
};
